const KEY = 'engagement-analytics-v1';

function generateData(days=30){
  const now = new Date();
  const segments = ['All','Web','Mobile','APAC','NA','EU'];
  const timeseries = [];
  for(let i=days-1;i>=0;i--){
    const d = new Date(now); d.setDate(now.getDate()-i);
    const baseUsers = 900 + Math.floor(Math.random()*400);
    const sessions = baseUsers * (1.2 + Math.random()*0.6);
    const interactions = Math.floor(sessions * (0.5 + Math.random()*0.4));
    const sat = 3.8 + Math.random()*1.0;
    timeseries.push({ date: d.toISOString().slice(0,10), users: baseUsers, sessions: Math.round(sessions), interactions, satisfaction: Number(sat.toFixed(2)), segment:'All' });
  }
  return { segments, timeseries };
}

function load(){
  try{ const raw = localStorage.getItem(KEY); return raw ? JSON.parse(raw) : generateData(30); }catch{ return generateData(30); }
}

let state = load();
const subs = new Set();
function save(){ try{ localStorage.setItem(KEY, JSON.stringify(state)); }catch{} }
function publish(){ save(); subs.forEach(cb=> { try{ cb(state); }catch{} }); }

export function subscribe(cb){ subs.add(cb); cb(state); return ()=> subs.delete(cb); }
export function regenerate(days=30){ state = generateData(days); publish(); }

export function filter({ from=null, to=null, segment='All' }={}){
  const fromDt = from ? new Date(from) : null;
  const toDt = to ? new Date(to) : null;
  let data = state.timeseries;
  if(segment && segment!=='All') data = data.filter(x=> x.segment===segment);
  if(fromDt) data = data.filter(x=> new Date(x.date) >= fromDt);
  if(toDt) data = data.filter(x=> new Date(x.date) <= toDt);
  return data;
}

export function computeKPIs(items){
  if(items.length===0) return { activeUsers:0, avgSession:'0m 0s', interactionRate:'0%', satisfaction: '0.0' };
  const users = items[items.length-1].users;
  const sessions = items.reduce((a,b)=> a + b.sessions, 0) / items.length;
  const interactionRate = items.reduce((a,b)=> a + (b.interactions / Math.max(1,b.sessions)), 0) / items.length;
  const satisfaction = items.reduce((a,b)=> a + b.satisfaction, 0) / items.length;
  const avgSessionSecs = 9*60 + Math.round((sessions % 90));
  const mm = Math.floor(avgSessionSecs/60), ss = avgSessionSecs%60;
  return {
    activeUsers: users,
    avgSession: `${mm}m ${ss}s`,
    interactionRate: `${Math.round(interactionRate*100)}%`,
    satisfaction: satisfaction.toFixed(1)
  };
}

export function getSegments(){ return state.segments || ['All']; }
export function exportJSON(){ return state; }
export function importJSON(obj){ if(!obj) return; state = obj; publish(); }
